import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { Table, Row, Col, Spin } from 'antd';
import { start_loading, end_loading } from 'src/core/actions/loader';
import newAlert from 'src/components/newAlert';

import {
  expandColumns,
  exampleColumn,
  expandColumn1 as expandNext,
} from './dataStructure/data';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const columns = exampleColumn;

const Tailan = () => {
  const dispatch = useDispatch();
  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);
  const [tableData, setTableData] = useState([]);

  const [loading, seTloading] = useState(true);
  const generateHmTailan = (month) => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === '0') {
        setTableData(content.mayagt_data);
        seTloading(false);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    socket.emit('request_in', {
      channel: 'ss013_03_view',
      content: {
        action_type: 'get_tt03_data',
        month,
        year: data_date.year,
      },
    });
    dispatch(start_loading({}));
  };

  useEffect(() => {
    if (data_date?.month) generateHmTailan(data_date?.month);
  }, [data_date]);

  const mainSummary = (list = []) => (
    <Table.Summary>
      {list.map((j) => (
        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={2}>
            <Row
              style={{
                width: '100% !important',
              }}
            >
              <Col
                style={{
                  textAlign: 'right',
                  paddingRight: 20,
                }}
                span={13}
              >
                {j.ner}
              </Col>
              <Col
                style={{
                  textAlign: 'center',
                }}
                span={1}
              >
                {j.mur}
              </Col>
              <Col
                style={{
                  textAlign: 'right',
                }}
                span={10}
              >
                {j.dun}
              </Col>
            </Row>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      ))}
    </Table.Summary>
  );

  const expandedRowRender = (data = null) => {
    if (data?.title) {
      return (
        <Table
          columns={expandColumns({ title: data?.title })}
          dataSource={data?.child}
          pagination={false}
        />
      );
    }
    if (data) {
      return (
        <Table columns={expandNext} dataSource={data} pagination={false} />
      );
    }
    return null;
  };
  if (loading) {
    return (
      <div className="loading-spin">
        <Spin indicator={antIcon} />
      </div>
    );
  }

  const title = () => (
    <>
      <div className="table-title-text-center bold">
        А. Тухайн сарын борлуулсан бараа, гүйцэтгэсэн ажил, үзүүлсэн
        үйлчилгээний нэмэгдсэн өртгийн албан татварын тооцоо
      </div>
    </>
  );

  return (
    <>
      <div
        style={{
          minWidth: 900,
          overflow: 'scroll',
        }}
      >
        <Table
          className="aa-tatvar-tailan"
          columns={columns}
          dataSource={tableData}
          expandable={{
            defaultExpandAllRows: true,
            expandedRowRender: (row) =>
              expandedRowRender(row?.subRow || row?.subChildren),
            expandIcon: () => '',
            rowExpandable: (row) => {
              if (!row?.subRow && !row?.subChildren) {
                return null;
              }
              return row;
            },
          }}
          rowClassName="role-row"
          scroll={{
            y: true,
            x: 'auto',
          }}
          pagination={false}
          summary={() => mainSummary([])}
          title={title}
        />
      </div>
    </>
  );
};

export default Tailan;
